import styled from 'styled-components';

export default styled.h1`
  font-family: ${({ theme }) => theme.fonts.regular};
  font-style: normal;
  /* font-weight: 700; */
  font-size: ${({ theme }) => theme.fontSizes.l};
  line-height: 27.6px;
  color: ${({ theme }) => theme.colors.elvitaTrueBlack};
  letter-spacing: 0.04em;
`;
